// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"view360Reports_mulitpleDropdown__3eFXL","loaderWrapper":"view360Reports_loaderWrapper__3xpVu","globalFilters":"view360Reports_globalFilters__QvPZI"};